// extracted by mini-css-extract-plugin
module.exports = {"work-log-section":"WorkLog_work-log-section__1k9nO","cards":"WorkLog_cards__1AvUH","icons":"WorkLog_icons__6sPfZ"};